import { type ReactNode, useMemo } from 'react';

function Slab(): ReactNode {
  return (
    <div className="h-[51.313px] animate-pulse rounded-md bg-white/[0.04]" />
  );
}

function weightedDelta(): number {
  const r = Math.random();
  if (r < 0.08) return 3;
  if (r < 0.2) return 0;
  if (r < 0.55) return 1;
  return 2;
}

function generateCounts(): number[] {
  const counts: number[] = [];
  let prev = 6 + Math.floor(Math.random() * 3);
  for (let i = 0; i < 6; i++) {
    const clamped = Math.max(2, Math.min(8, prev));
    counts.push(clamped);
    const delta = weightedDelta();
    const bias = clamped >= 7 ? -1 : clamped <= 3 ? 1 : 0;
    const sign = Math.random() < 0.55 + bias * 0.3 ? -1 : 1;
    prev = clamped + delta * sign;
  }
  return counts;
}

export function useSkeletonCounts(): number[] {
  return useMemo(generateCounts, []);
}

export function ColumnSkeleton({ count }: { count: number }): ReactNode {
  return (
    <div className="animate-fade-in space-y-xs">
      {Array.from({ length: count }, (_, i) => (
        <Slab key={i} />
      ))}
    </div>
  );
}
